import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { emit, label, renderChildren, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<div class="slex-collapsible"><button type="button" class="slex-collapsible-trigger"><span class="slex-collapsible-label"><!> <span> </span></span> <span class="slex-collapsible-indicator" aria-hidden="true"></span></button> <div class="slex-collapsible-content"><div class="slex-collapsible-content-inner"> </div></div></div>`);

export default function Collapsible($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let open = $.state(false);

	$.user_effect(() => bindPropStore($$props.props, (next) => {
		$.set(p, next, true);
		$.set(open, !!(next.open ?? next.value));
	}));

	function toggle() {
		$.set(open, !$.get(open));
		emit($$props.ctx, $.get(open) ? "open" : "close", $.get(open));
		emit($$props.ctx, "change", $.get(open));
	}

	var div = root();
	var button = $.child(div);
	var span = $.child(button);
	var node = $.child(span);

	{
		var consequent = ($$anchor) => {
			InlineIcon($$anchor, {
				get name() {
					return $.get(p).icon;
				},

				get selected() {
					return $.get(open);
				},
				className: 'slex-collapsible-icon'
			});
		};

		$.if(node, ($$render) => {
			if ($.get(p).icon) $$render(consequent);
		});
	}

	var span_1 = $.sibling(node, 2);
	var text_1 = $.child(span_1, true);

	$.reset(span_1);
	$.reset(span);
	$.next(2);
	$.reset(button);

	var div_1 = $.sibling(button, 2);
	var div_2 = $.child(div_1);
	var text_2 = $.child(div_2, true);

	$.reset(div_2);
	$.action(div_2, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);
	$.reset(div_1);
	$.reset(div);

	$.template_effect(
		($0, $1) => {
			$.set_attribute(div, 'data-state', $.get(open) ? "open" : "closed");
			$.set_attribute(button, 'data-state', $.get(open) ? "open" : "closed");
			$.set_attribute(button, 'aria-expanded', $.get(open));
			$.set_attribute(button, 'aria-controls', `${$$props.ctx.id}-content`);
			$.set_text(text_1, $0);
			$.set_attribute(div_1, 'id', `${$$props.ctx.id}-content`);
			$.set_attribute(div_1, 'data-state', $.get(open) ? "open" : "closed");
			$.set_attribute(div_1, 'aria-hidden', !$.get(open));
			$.set_text(text_2, $1);
		},
		[
			() => label($$props.ctx, "collapsible.trigger", $.get(p).trigger, "Toggle"),
			() => text($.get(p).content)
		]
	);

	$.delegated('click', button, toggle);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);